import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatOption, MatSelect } from '@angular/material/select';
import { Store } from '@ngrx/store';
import { rateAnswer, submitFeedback } from '../../../../store/answer/rateAnswer.action';
import { HttpRequestService } from '../../../../utilities/http/request.utilities';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-rate-answer',
  standalone: true,
  imports: [MatIcon, MatIconModule, MatSelect, MatOption, CommonModule, FormsModule],
  templateUrl: './rate-answer.component.html',
  styleUrl: './rate-answer.component.css'
})
export class RateAnswerComponent {
  showFeedbackForm = false;
  selectedReason: string = '';
  additionalFeedback: string = '';
  selectedRating: 'like' | 'dislike' | null = null;
  @Input() transactionId: string = '';

  constructor(private httpRequestService: HttpRequestService,  private store: Store) {}

  submitLike() {
    const ratingData = { answerLikeButton: true };
    this.selectedRating = 'like';
    this.showFeedbackForm = false;
    this.submitRating(ratingData);
  }

  submitDislike() {
    const ratingData = { answerLikeButton: false };
    this.selectedRating = 'dislike';
    this.showFeedbackForm = true;
  }

  private submitRating(payload: { answerLikeButton: boolean }) {
    const endpoint = `${environment.integrations.transactionFeedback}/${this.transactionId}`;
    this.postTransactionFeedback(endpoint, payload)
      .then(() => {
        console.log('Rating submitted successfully');
      })
      .catch((error) => {
        console.error('Error submitting rating:', error);
        alert('An error occurred while submitting the rating. Please try again.');
      });

    this.store.dispatch(rateAnswer({ rating: payload.answerLikeButton }));
  }

  submitFeedback(): void {
    this.showFeedbackForm = false;
    if (!this.selectedReason) {
      alert('Please select a reason before submitting.');
      return;
    }

    const payload = {
      answerLikeButton: this.selectedRating === 'like',
      reason: this.selectedReason,
      feedback: this.additionalFeedback || '',
    };

    const endpoint = `${environment.integrations.transactionFeedback}/${this.transactionId}`;

    this.postTransactionFeedback(endpoint, payload)
      .then(() => {
        this.selectedReason = '';
        this.additionalFeedback = '';
      })
      .catch((error) => {
        console.error('Error submitting feedback:', error);
        alert('An error occurred while submitting feedback. Please try again.');
      });
  }

  private async postTransactionFeedback(endpoint: string, payload: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.httpRequestService.request<any>('POST', endpoint, payload).subscribe({
        next: (response) => resolve(response),
        error: (error) => reject(error),
      });
    });
  }

}
